import { computed, unref, type MaybeRef } from 'vue'
import { createQuery } from '@/queries'
import { getGiftConfig, type GiftConfig } from '@/features/gift-quiz/api/gift-config'

/** BE-153 — `GET /gift/config?currency=`; the labels follow the request's `Accept-Language`. */
export const useGiftConfigQuery = (currency: MaybeRef<string>, enabled: MaybeRef<boolean> = true) => {
  return createQuery<GiftConfig>({
    key: computed(() => (unref(enabled) ? ['gift-config', unref(currency)] : null)),
    fetcher: async () => {
      const response = await getGiftConfig(unref(currency))
      return response.data
    },
    staleTime: 60 * 60 * 1000,
  })
}
